import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showSuccessToast } from '@utils'
import { useLanguage } from '@context'
import { useApiErrorHandler } from '../../../useApiErrorHandler'

interface UpdateKeepContactData {
  id: string
  name?: string
  description?: string
  contactAccountId?: string
  date?: string
  rrule?: string | null
  location?: { place: string; city?: string; country?: string; state?: string; region?: string } | null
  hasReminder?: boolean
}

const updateKeepContact = async (data: UpdateKeepContactData): Promise<void> => {
  const { id, ...updateData } = data
  await api.put(`/keep-contact/${id}`, updateData)
}

export const useUpdateKeepContact = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()
  const handleApiError = useApiErrorHandler()

  return useMutation<void, Error, UpdateKeepContactData>({
    mutationFn: updateKeepContact,
    onSuccess: async (_, variables) => {
      showSuccessToast(t('toast.success'), t('toast.reminderUpdated'))
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['keep-contacts'] }),
        queryClient.invalidateQueries({ queryKey: ['keep-contact', variables.id] }),
      ])
    },
    // A refused save says so instead of failing in silence.
    onError: handleApiError,
  })
}

